
import moment from "moment";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from "primereact/inputtext";
import { MultiSelect } from 'primereact/multiselect';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import Countdown from 'react-countdown';
import 'react-slideshow-image/dist/styles.css';
import '../Helper/links';
import { _endPoints, getapartments, getbookings } from "../Helper/links";
import { pattern } from '../Helper/pattern';
import API from "../Helper/server/API";
import { InvoiceContext } from '../bookings/invoice/Invoice_Context';
import InvoiceBookingesReport from "../bookings/invoice/invoice_bookinges_report";
import { View_count_days, View_price_day } from "../constants/dataView";
import before_days from "../functions/print_date_before_days";
import view_apartment_type_ar from "../functions/view_apartment_type";
import view_day_ar from "../functions/view_day_ar";
import '../public/themes/saga-blue/theme.css';

function ReportBookinges() {

    const toast = useRef(null);
    const Completionist = () => <span>تم الغاء الحجز</span>;
    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12'],
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
    });
    const [year, setYear] = useState(new Date());
    const handel_year = (e) => {
        if (moment(e.value).format('YYYY') * 1 <= new Date().getFullYear() && moment(e.value).format('YYYY') * 1 >= new Date(new Date().setFullYear(2024)).getFullYear()) {
            setYear(e.value)
            GetAllReservationes(e.value.getFullYear())
        }
    }
    //_____________________________________________________________________
    const [apartments, setApartments] = useState([]);
    const [apartments_view, setApartments_view] = useState([]);
    const paid_type = ['all', 'paid', 'not_paid'];
    const [paid_type_view, setPaidTypeView] = useState('all');
    //_____________________________________________________________________
    const [reservationes, set_reservationes] = useState([]);
    const [reservationes_view, set_reservationes_view] = useState([]);
    const [loading_reservationes_view, set_loading_reservationes_view] = useState(false);
    const [data_show, set_data_show] = useState({
        ID_reservation: true,
        visitor_name: true,
        phone_number: true,
        ID_apartment: true,
        date_check_in: true,
        days: true,
        price_day: true,
        total_price: true,
        total_paid: true,
        card_paid: true,
        rest: true,
        discount_value: true,
        notes: true,
        date_create: true,
        username: true,
        footer_total_price: true,
        footer_total_paid: true,
        footer_total_rest: true,
        footer_total_discount_value: false,
    });
    const [loading_apartment, set_loading_apartment] = useState(false);
    //_____________________________________________________________________
    const [selectedReservationes, setSelectedReservationes] = useState([]);
    //______________________________________________________________________
    const [search_date, setsearch_date] = useState([]);
    const [name_phone, setname_phone] = useState("");
    const [ID_reservation, setID_reservation] = useState("");
    const [disabled_search, set_disabled_search] = useState(false);
    //_______________________________________________________________________
    const statusBodyTemplate = (reservation) => {
        if (reservation.total_price - reservation.total_paid === 0) {
            return <Tag style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "17px" }}
                value={"خالص"} severity="success">
            </Tag>;
        }
        else {
            return <Tag style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "17px" }}
                value={reservation.total_price - reservation.total_paid + "د.ل"} severity="danger">
            </Tag>;
        }
    };
    const ID_reservationBodyTemplate = (reservation) => {
        var diffInMs = new Date(moment(reservation.date_del_reservation).format("yyyy-MM-DD")) - new Date(moment(new Date()).format("yyyy-MM-DD"));
        var diffInDays = diffInMs / (1000 * 60 * 60 * 24);
        return (
            <>
                {reservation.ID_reservation}

                {

                    reservation.date_del_reservation ?
                        <span style={{ color: "red" }}>
                            <br></br>
                            <Countdown date={reservation.date_del_reservation}
                                renderer={renderer}
                            >
                            </Countdown>
                            <br></br>
                            {diffInDays > 0 ? diffInDays + " آيــام " : null}
                        </span>
                        : null
                }
            </>
        );
    };
    const ApartmentBodyTemplate = (reservation) => {
        return (
            <>
                {view_apartment_type_ar(reservation.type) + "-" + reservation.number + " "}
            </>
        );
    };
    const PhoneTemplate = (reservation) => {
        return (
            <>
                <a href={"tel:+218" + reservation.phone_number}>{reservation.phone_number}</a>
                <br></br>
                <a href={"tel:+218" + reservation.whatsapp_number}>{reservation.whatsapp_number}</a>
            </>
        );
    };

    const Date_CheckInBodyTemplate = (reservation) => {
        return (
            <>
                {moment(reservation.date_check_in).format("YYYY-MM-DD")}
                <br></br>
                {view_day_ar(reservation.date_check_in)}
            </>
        );
    };
    const Date_CheckOutBodyTemplate = (reservation) => {
        return (
            <>
                {moment(reservation.date_check_out).format("YYYY-MM-DD")}
                <br></br>
                {view_day_ar(reservation.date_check_out)}
            </>
        );
    };
    const Total_PriceBodyTemplate = (reservation) => {
        return reservation.total_price + "د.ل";
    };


    const Total_PaidBodyTemplate = (reservation) => {
        return reservation.total_paid === 0 ? "-" : reservation.total_paid + "د.ل";
    };
    const Total_discound_valueBodyTemplate = (reservation) => {
        if (reservation.discount_value > 0) {
            return (
                <p>{reservation.discount_value + " د.ل"}</p>
            );
        }
        else {
            return 0;
        }

    };
    const DateCreate_BodyTemplate = (reservation) => {
        return (
            <p>
                {before_days(reservation.date_create)}
                <br></br>
                {moment(reservation.date_create).format("LT")}
            </p>
        );
    };
    const CustomerTemplate = (reservation) => {
        return (
            <>
                {data_show.visitor_name ? reservation.visitor_name : null}
                {
                    data_show.phone_number ?
                        <>
                            <br></br>
                            <a style={{ color: "#495057" }} href={"tel:+218" + reservation.phone_number}>{reservation.phone_number}</a>
                            <br></br>
                            {reservation.whatsapp_number && reservation.whatsapp_number !== "null" ?
                                <>
                                    <a style={{ color: "#495057" }} href={"tel:+" + reservation.whatsapp_number} dir="ltr">{reservation.whatsapp_number}</a>
                                    <i className="fa fa-whatsapp pr-1" style={{ color: "green", width: "2px" }}></i>
                                </>
                                :
                                <></>
                            }
                        </> : null
                }
            </>
        );
    };
    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <Completionist />;
        } else {
            // Render a countdown
            return <span>
                {hours}:{minutes}:{seconds}

            </span>;
        }
    };
    //____________________________________________________________
    const [Invoice, setInvoice] = useState(false);
    //____________________________________________________________
    const handel_ID_reservation = (e) => {
        if (pattern.number_int.test(e.target.value) === true) {
            setID_reservation(e.target.value);
            set_disabled_search(true);
        }
        else if (e.target.value === '' || e.target.value === null) {
            setID_reservation(e.target.value);
            set_disabled_search(false);
        }
    }
    const renderHeader = () => {
        return (
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-11">
                        <div className="flex justify-content-between" style={{ fontFamily: "Cairo", fontSize: "15px" }} dir="rtl">
                            <InputText
                                value={ID_reservation}
                                onChange={(e) => handel_ID_reservation(e)}
                                placeholder="رقم الحجز"
                                className="col-md-1"
                                maxLength={6}
                                style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%" }}
                            />
                            <InputText
                                value={name_phone}
                                onChange={(e) => setname_phone(e.target.value)}
                                placeholder="الأسم أو رقم الهاتف"
                                className="col-md-4"
                                style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%" }} disabled={disabled_search}
                            />
                            <MultiSelect
                                options={apartments}
                                value={apartments_view}
                                itemTemplate={ApartmentsViewItemTemplate}
                                onChange={(e) => setApartments_view(e.target.value)}
                                optionLabel="number"
                                display="chip"
                                placeholder="اختار مكان الاقامة"
                                emptyMessage={<p style={{ fontFamily: "Cairo", textAlign: "center" }}>لا توجد خيارات متاحة</p>}
                                loading={loading_apartment}
                                className="col-md-2"
                                maxSelectedLabels={3}
                                style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%" }} disabled={disabled_search}
                            />
                            <Calendar locale="ar" selectionMode="range" readOnlyInput hideOnRangeSelection className="col-md-2" placeholder="تاريخ الاستلام"
                                value={search_date} onChange={(e) => e.value ? setsearch_date(e.value) : setsearch_date([])} dateFormat="yy-mm-dd" showButtonBar
                                style={{ fontFamily: "Cairo", width: "100%", paddingRight: "0px", paddingLeft: "0px" }} disabled={disabled_search}
                                panelStyle={{ fontFamily: "Cairo" }}
                            />

                            <Dropdown dir="rtl" value={paid_type_view} valueTemplate={PaidViewTemplate}
                                options={paid_type} onChange={(e) => setPaidTypeView(e.value)}
                                itemTemplate={PaidViewTemplate} className="col-md-2"
                                panelStyle={{ textAlign: 'right', direction: "rtl" }} disabled={disabled_search} />

                            <Button
                                dir="ltr"
                                type="button"
                                icon="fa fa-remove"
                                outlined
                                severity="danger"
                                onClick={clearFilter}
                                style={{ marginRight: "0px" }}
                                disabled={
                                    loading_reservationes_view || loading_apartment ?
                                        true : false
                                }
                            />
                            <Button
                                dir="ltr"
                                type="button"
                                icon="fa fa-search"
                                outlined
                                onClick={search}
                                style={{ marginRight: "5px" }}
                                disabled={
                                    loading_reservationes_view || loading_apartment ?
                                        true : false
                                }
                            />

                        </div>
                    </div>
                    <div className="col-md-1" style={{ textAlign: "left" }}>
                        <Button icon="fa fa-refresh" rounded outlined onClick={() => {
                            GetAllReservationes()
                        }} />
                    </div>
                </div>

            </div>
        );
    };

    const renderHowShow = () => {
        return (
            <div className="col-md-12">
                <center>
                    <h6>بيانات الحجز</h6>
                    <hr></hr>
                </center>
                <div className="row">
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>رقم الحجز</label>
                            <Button icon={data_show.ID_reservation ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.ID_reservation ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.ID_reservation ? { ...data_show, ID_reservation: false } : { ...data_show, ID_reservation: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>اسم العميل</label>
                            <Button icon={data_show.visitor_name ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.visitor_name ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.visitor_name ? { ...data_show, visitor_name: false } : { ...data_show, visitor_name: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label> رقم العميل</label>
                            <Button icon={data_show.phone_number ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.phone_number ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.phone_number ? { ...data_show, phone_number: false } : { ...data_show, phone_number: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label> الاقامة</label>
                            <Button icon={data_show.ID_apartment ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.ID_apartment ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.ID_apartment ? { ...data_show, ID_apartment: false } : { ...data_show, ID_apartment: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-2 col-4 mb-2">
                        <center>
                            <label>الاستلام والمغادرة</label>
                            <Button icon={data_show.date_check_in ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.date_check_in ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.date_check_in ? { ...data_show, date_check_in: false } : { ...data_show, date_check_in: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label> عدد الايام</label>
                            <Button icon={data_show.days ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.days ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.days ? { ...data_show, days: false } : { ...data_show, days: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>سعر اليوم</label>
                            <Button icon={data_show.price_day ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.price_day ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.price_day ? { ...data_show, price_day: false } : { ...data_show, price_day: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label> الاجمالي</label>
                            <Button icon={data_show.total_price ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.total_price ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.total_price ? { ...data_show, total_price: false } : { ...data_show, total_price: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label> المدفوع</label>
                            <Button icon={data_show.total_paid ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.total_paid ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.total_paid ? { ...data_show, total_paid: false } : { ...data_show, total_paid: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label> طريقة الدفع</label>
                            <Button icon={data_show.card_paid ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.card_paid ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.card_paid ? { ...data_show, card_paid: false } : { ...data_show, card_paid: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>الباقي</label>
                            <Button icon={data_show.rest ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.rest ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.rest ? { ...data_show, rest: false } : { ...data_show, rest: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>التخفيض</label>
                            <Button icon={data_show.discount_value ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.discount_value ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.discount_value ? { ...data_show, discount_value: false } : { ...data_show, discount_value: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>ملاحظات</label>
                            <Button icon={data_show.notes ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.notes ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.notes ? { ...data_show, notes: false } : { ...data_show, notes: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>وقت الحجز</label>
                            <Button icon={data_show.date_create ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.date_create ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.date_create ? { ...data_show, date_create: false } : { ...data_show, date_create: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-2 col-4 mb-2">
                        <center>
                            <label>الحجز عن طريق</label>
                            <Button icon={data_show.username ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.username ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.username ? { ...data_show, username: false } : { ...data_show, username: true })} className="col-md-12" />
                        </center>
                    </div>
                </div>
                <hr></hr>
                <center>
                    <h6>بيانات الحجز</h6>
                    <hr></hr>
                </center>
                <div className="row">
                    <div className="col-md-3 col-3 mb-2">
                        <center>
                            <label>إجمالي المبلغ</label>
                            <Button icon={data_show.footer_total_price ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.footer_total_price ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.footer_total_price ? { ...data_show, footer_total_price: false } : { ...data_show, footer_total_price: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-3 col-3 mb-2">
                        <center>
                            <label>إجمالي المدفوع</label>
                            <Button icon={data_show.footer_total_paid ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.footer_total_paid ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.footer_total_paid ? { ...data_show, footer_total_paid: false } : { ...data_show, footer_total_paid: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-3 col-3 mb-2">
                        <center>
                            <label>إجمالي المتبقي</label>
                            <Button icon={data_show.footer_total_rest ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.footer_total_rest ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.footer_total_rest ? { ...data_show, footer_total_rest: false } : { ...data_show, footer_total_rest: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-3 col-3 mb-2">
                        <center>
                            <label>إجمالي التخفيض</label>
                            <Button icon={data_show.footer_total_discount_value ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.footer_total_discount_value ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.footer_total_discount_value ? { ...data_show, footer_total_discount_value: false } : { ...data_show, footer_total_discount_value: true })} className="col-md-12" />
                        </center>
                    </div>

                </div>

            </div>
        );
    };
    const search = (e) => {
        e.preventDefault();
        // setname_phone(e.target.value);
        // setcheck_in("");
        // SearchReservationes();
        // If the text field is empty, show all users
        //___________________________________________________________________
        //                  Search On Old Reservationes
        var reservationes_search_apt = [];
        var reservationes_search_coming = [];
        reservationes?.map((res) =>
        (
            // eslint-disable-next-line array-callback-return
            apartments_view?.map((apt) => {
                if (
                    res.ID_apartment === apt.ID_apartment
                ) {
                    reservationes_search_apt.push(res);
                }
            })
        ))
        // eslint-disable-next-line array-callback-return
        reservationes_search_apt?.map((res) => {
            if (ID_reservation !== '' && ID_reservation !== false) {
                if (
                    (res.ID_reservation.toString()).startsWith(ID_reservation)
                    || (res.ID_reservation.toString()).endsWith(ID_reservation)
                    || res.ID_reservation === ID_reservation
                ) {
                    reservationes_search_coming.push(res);
                }
            }
            else if (
                (
                    !name_phone || name_phone.toString().trim() === "" ||
                    (
                        (res.visitor_name != null && (res.visitor_name.toString().startsWith(name_phone.toString())
                            || res.visitor_name.toString().endsWith(name_phone.toString())))
                        //_____________________________________________
                        || (res.phone_number != null && (res.phone_number.toString().startsWith(name_phone.toString())
                            || res.phone_number.toString().endsWith(name_phone.toString())))
                        //_____________________________________________
                        || (res.whatsapp_number != null && (res.whatsapp_number.toString().startsWith(name_phone.toString())
                            || res.whatsapp_number.toString().endsWith(name_phone.toString())))
                    )
                )
                &&
                //_____________________________________________
                (
                    (paid_type_view === 'paid' && res.total_paid === res.total_price)
                    ||
                    (paid_type_view === 'not_paid' && res.total_paid !== res.total_price)
                    ||
                    paid_type_view === 'all'
                )
                &&
                (
                    (
                        search_date.length > 0
                        &&
                        moment(res.date_check_in).format('yyyy-MM-DD') >= moment(search_date[0]).format('yyyy-MM-DD')
                        &&
                        (
                            (
                                search_date.length > 1
                                &&
                                moment(res.date_check_in).format('yyyy-MM-DD') <= moment(search_date[1]).format('yyyy-MM-DD')
                            )
                            || search_date[1] === null
                        )
                    )
                    ||
                    search_date === null || search_date.length === 0

                )

            ) {
                reservationes_search_coming.push(res);
            }
        })
        set_reservationes_view(reservationes_search_coming);
    };
    const clearFilter = () => {
        setID_reservation("")
        setname_phone("");
        setsearch_date([])
        setPaidTypeView('all')
        GetApartment();
        GetAllReservationes(year.getFullYear())
    };
    const print = () => {
        setInvoice(true);
    };
    //_______________________________________________________________________________________
    //                      Get Reservationes

    const GetApartment = async () => {
        set_loading_apartment(true);
        const response = await API.get(_endPoints.apartments.get_apartments)
        if (response?.success === 1) {
            setApartments(response.data);
            setApartments_view(response.data);
        }
        set_loading_apartment(false);
    }
    const GetAllReservationes = async (year) => {
        set_loading_reservationes_view(true)
        if (!year)
            year = new Date().getFullYear()
        const response = await API.get(`${getbookings}?year=${year}`)
        if (response?.success === 1) {
            set_reservationes(response?.reservationes);
            //__________________________________________________________
            set_reservationes_view(response?.reservationes);
            // Filter Reservationes
        }
        else if (response?.success === 0) {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }
        set_loading_reservationes_view(false)
    }
    const ApartmentsViewItemTemplate = (apt) => {
        return (
            <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl" }} >
                <span>{view_apartment_type_ar(apt.type)} - {apt.number}</span>
            </div>
        );
    };
    const PaidViewTemplate = (value) => {
        return (
            <>
                <Tag style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "13px", textAlign: "right", maxHeight: "22px" }}
                    value={value === 'all' ? 'الكل' : value === 'paid' ? "خالص" : "غير خالص"} severity={value === 'all' ? 'info' : value === 'paid' ? "success" : "danger"}>
                </Tag>
            </>
        );
    };
    const footer = () => {
        return (
            <>
                <div className="ibox-body" style={{ textAlign: "center", padding: "10px" }}>
                    <div className="row" style={{ fontSize: "15px" }}>
                        <div className="col-md-4" >
                            <strong className="col-md-10">   تحديد {selectedReservationes.length} حجوزات </strong>
                            <Button
                                dir="ltr"
                                type="button"
                                icon="pi pi-filter-slash"
                                text
                                severity="danger"
                                onClick={() => { setSelectedReservationes([]) }}
                            />
                        </div>
                        <div className="col-md-8">
                            <>
                                <div className="row">
                                    <div className="col-md-3 col-6 mb-2">
                                        <Button icon="fa fa-print" dir="ltr" outlined label="طبــاعة " className="col-12" severity="secondary" aria-label="طباعة" onClick={print} disabled={selectedReservationes.length > 0 ? false : true} />
                                    </div>

                                </div>
                            </>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    useEffect(() => {
        GetApartment();
        GetAllReservationes(new Date().getFullYear());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="page-wrapper" dir="rtl" >
            <div className="content-wrapper">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
                <div className="page-heading">
                    <h1 className="page-title"> تقـاريـر الحجــوزات
                        <Calendar value={year} onChange={(e) => handel_year(e)} view="year" dateFormat="yy" className="col-md-1 mt-2" style={{ fontFamily: "Cairo" }} panelStyle={{ fontFamily: "Cairo" }}
                            minDate={new Date(new Date().setFullYear(2024))}
                            maxDate={new Date()}
                            disabled={loading_reservationes_view}
                        />

                    </h1>
                </div>
                <div className="card">
                    <Accordion  >
                        <AccordionTab header=" طريقة عرض التقــرير " style={{ fontFamily: "Cairo" }} >
                            {renderHowShow()}
                        </AccordionTab>
                    </Accordion>
                    <br></br>
                    {renderHeader()}
                    <DataTable value={reservationes_view} loading={loading_reservationes_view}
                        dataKey="ID_reservation"
                        selectionMode="multiple" selection={selectedReservationes} onSelectionChange={(e) => setSelectedReservationes(e.value)}
                        metaKeySelection={false} dragSelection
                        stripedRows removableSort
                        paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                        scrollable scrollHeight="750px"
                        sortMode="multiple"
                        size="normal"

                        footer={footer}
                        emptyMessage={<center><h4>لا يوجد حجوزات</h4></center>}
                        tableStyle={{ minWidth: '50rem' }}
                        style={{ fontFamily: "Cairo", direction: "rtl", border: "10px" }}
                    >
                        <Column selectionMode="multiple" style={{ width: '1%', textAlign: "right" }}></Column>
                        {data_show.ID_reservation ? <Column field="ID_reservation" body={ID_reservationBodyTemplate} header="الحجز" sortable style={{ width: '2%', textAlign: "right" }}></Column> : null}
                        {data_show.visitor_name || data_show.phone_number ? <Column field="visitor_name" body={CustomerTemplate} header="العميــل" sortable style={{ width: '10%', textAlign: "right" }}></Column> : null}
                        {data_show.ID_apartment ? <Column field="number" header="الاقامة" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                            body={ApartmentBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column> : null}
                        {data_show.date_check_in ? <Column field="date_check_in" header="الاستلام" body={Date_CheckInBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> : null}
                        {data_show.date_check_in ? <Column field="date_check_out" header="المغادرة" body={Date_CheckOutBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> : null}
                        {data_show.days ? <Column field="date_check_in" header="الأيام" body={View_count_days} style={{ width: '1%', textAlign: "right" }}></Column> : null}
                        {data_show.price_day ? <Column field="total_price" header="سعر اليوم" body={View_price_day} sortable style={{ width: '5%', textAlign: "right" }}></Column> : null}
                        {data_show.total_price ? <Column field="total_price" header="الإجمالي" body={Total_PriceBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column> : null}
                        {data_show.total_paid ? <Column field="total_paid" header="المدفوع" body={Total_PaidBodyTemplate} sortable style={{ width: '5%', textAlign: "right", color: "green" }}></Column> : null}
                        {data_show.rest ? <Column header="الباقي" field="rest" body={statusBodyTemplate} sortable style={{ width: '5%', textAlign: "right", color: "red" }} ></Column> : null}
                        {data_show.discount_value ? <Column field="discount_value" header="التخفيض" body={Total_discound_valueBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column> : null}
                        {data_show.notes ? <Column field="notes" header="ملاحظات" style={{ width: '5%', textAlign: "right" }}></Column> : null}
                        {data_show.date_create ? <Column field="date_create" header="وثت الحجز" body={DateCreate_BodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> : null}
                        {data_show.username ? <Column field="name" header="الحجز عن طريق" style={{ width: '10%', textAlign: "right" }}></Column> : null}
                    </DataTable>
                </div>
                {
                    Invoice ?
                        (
                            <Dialog dir="rtl" header="فاتورة الحجوزات" visible={Invoice} maximizable style={{ width: '90vw', fontFamily: "Cairo" }} onHide={() => setInvoice(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                                <InvoiceContext.Provider value={{
                                    reservations: selectedReservationes,
                                    data_show: data_show
                                }} >
                                    {Invoice && <InvoiceBookingesReport></InvoiceBookingesReport>}
                                </InvoiceContext.Provider>
                            </Dialog>
                        )
                        :
                        (null)
                }
            </div>
        </div>
    )
}

export default ReportBookinges


